// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","column":"hUfkTeLpj-ye","menuItem":"TgeDmD3HhYIO"};